import getCollection from './getCollection'
import getDataById from 'actions/base/getDataById'

const getBooking = async (id) => getDataById(id, getCollection)

export default getBooking
